import {
  faAngleLeft,
  faChevronDown,
  faEye,
  faPen,
  faPlus,
  faTrashCan,
  faUpload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useRef, useState } from "react";
import { Button, Form, InputGroup, Modal, Table } from "react-bootstrap";
import rejectAnimation from "../../../../../animation/success_lottie/Reject_lottie.json";
import Success_modal from "../../../../../common_components/common_modal/success_modal/Success_modal";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../../../utils/IDS";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";
import { DeleteState } from "../../../../../../features/admin/masters/state/Slice";
import { useDispatch, useSelector } from "react-redux";
import { FixIDS } from "../../../../../../utils/common";
import { Context } from "../../../../../../utils/context";
import { allTicketStatus } from "../../../../../../features/admin/common/Slice";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { Controller } from "react-hook-form";
import { UpdateTicketStatus } from "../../../../../../features/admin/ticketraise/Slice";
import "./ticket_table.css";

const Ticket = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    control,
  } = useForm();
  const dispatch = useDispatch();
  const allticketStatus = useSelector(
    (state) => state.common.all_ticket_status
  );

  useEffect(() => {
    dispatch(allTicketStatus());
  }, [dispatch]);
  const { isAllow: permissions, usertype } = useContext(Context);

  const hasPermission = (ids) => {
    if (usertype === "admin") return true;
    if (!Array.isArray(permissions)) return false;
    return ids.some((id) => permissions.includes(id));
  };

  const { country, name, setName, fetch } = IndexUse();

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const [modalRejectShow, setModalRejectShow] = useState(false);
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showEditCanvas, setShowEditCanvas] = useState(false);
  const [openStatus, setOpenStatus] = useState(false);
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const courseRef = useRef(null);
  const handleStatusSelect = (status) => {
    console.log(status);
    setOpenStatus(false);
  };

  useEffect(() => {
    const handleClick = (e) => {
      if (courseRef.current && !courseRef.current.contains(e.target))
        setOpenStatus(false);
    };

    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <>
      <section className="Collage_intern application_section ticket_table_div">
        <div className="serach_header">
          {/* Search */}
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search Country"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Tickets</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive>
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Name </th>
                  <th>Contact Number </th>
                  <th>Subject </th>
                  <th>Description </th>
                  <th>Ticket Status </th>
                </tr>
              </thead>

              <tbody>
                {country?.data?.length > 0 ? (
                  country?.data?.map((val, index) => (
                    <tr key={index}>
                      <td>
                        {(country?.current_page - 1) * country?.per_page +
                          index +
                          1}
                      </td>
                      <td>{val?.name}</td>
                      <td>{val?.contact_no}</td>
                      <td>{val?.subject}</td>
                      <td>{val?.description}</td>
                      {/* <td>
                        <div className="action_btn_holder">
                          {permissions?.includes(
                            IDS.Permission.Ticket.Edit
                          ) && (
                            <Button
                              className="eye_btn action_btn_icon"
                              onClick={() => setShowEditCanvas(val?.id)}
                            >
                              <FontAwesomeIcon icon={faPen} />
                            </Button>
                          )}
                        </div>
                      </td> */}

                      <td style={{ minWidth: "220px" }}>
                        <Controller
                          name={`ticket_status_${val?.id}`}
                          control={control}
                          defaultValue={
                            allticketStatus?.find(
                              (s) => s.value === val?.ticket_status_id
                            ) || null
                          }
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={allticketStatus}
                              placeholder="Select Status"
                              isClearable
                              onChange={(selected) => {
                                field.onChange(selected);

                                if (!selected) return;

                                dispatch(
                                  UpdateTicketStatus({
                                    id: val?.id,
                                    ticket_status_id: selected.value,
                                  })
                                );
                              }}
                            />
                          )}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center fw-bold">
                      No Data
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <CustomPaginate
              currentPage={country?.current_page}
              totalPages={country?.total_pages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      <Success_modal
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        message_text="Application Rejected"
        animationData={rejectAnimation}
      />
    </>
  );
};

export default Ticket;
